import { useState } from "react";
import { ewaiverApi } from "../api/ewaiver.service";
import { EwaiverUpdatePayload } from "../api";

export const buildEwaiverEditFormData = (
  data: EwaiverUpdatePayload
): FormData => {
  const form = new FormData();

  form.append("event_id", data.event_id);
  form.append("is_have_online_checkin", String(+data.is_have_online_checkin));
  form.append("start_checkin_online_date", data.start_checkin_online_date);
  form.append("end_checkin_online_date", data.end_checkin_online_date);
  if (data.authorization_form_url)
    form.append("authorization_form_url", data.authorization_form_url);
  if (data.disclaimer_form_url)
    form.append("disclaimer_form_url", data.disclaimer_form_url);
  form.append("t_and_c_link", data.t_and_c_link);

  if (data.ewaiver_banner_url)
    form.append("ewaiver_banner_url", data.ewaiver_banner_url);

  if (data.ewaiver_file instanceof File) {
    form.append("ewaiver_file", data.ewaiver_file);
  }
  form.append("delete_file", String(+data.delete_file));

  if (data.waiver_sign_required !== undefined)
    form.append("waiver_sign_required", String(+data.waiver_sign_required));
  if (data.is_sent_to_authorizer !== undefined)
    form.append("is_sent_to_authorizer", String(+data.is_sent_to_authorizer));
  if (data.send_bib_via_email !== undefined)
    form.append("send_bib_via_email", String(+data.send_bib_via_email));
  form.append("is_show_send_ewaiver", String(+(data.is_show_send_ewaiver ?? false)));
  form.append("is_show_send_qrcode", String(+(data.is_show_send_qrcode ?? false)));

  if (data.is_change_pickup_method !== undefined)
    form.append(
      "is_change_pickup_method",
      String(+data.is_change_pickup_method)
    );
  if (data.number_of_times_change_pickup !== undefined)
    form.append(
      "number_of_times_change_pickup",
      String(data.number_of_times_change_pickup)
    );

  if (data.is_change_authorized_info !== undefined)
    form.append(
      "is_change_authorized_info",
      String(+data.is_change_authorized_info)
    );
  if (data.number_of_times_update_authorized_info !== undefined)
    form.append(
      "number_of_times_update_authorized_info",
      String(data.number_of_times_update_authorized_info)
    );

  if (data.only_authorize !== undefined)
    form.append("only_authorize", String(+data.only_authorize));

  if (data.kyc_required !== undefined)
    form.append("kyc_required", String(+data.kyc_required));
  if (data.kyc_ocr_limit !== undefined)
    form.append("kyc_ocr_limit", String(data.kyc_ocr_limit));
  if (data.kyc_face_matching_limit !== undefined)
    form.append(
      "kyc_face_matching_limit",
      String(data.kyc_face_matching_limit)
    );
  if (data.kyc_face_matching_ratio !== undefined)
    form.append(
      "kyc_face_matching_ratio",
      String(data.kyc_face_matching_ratio)
    );

  if (data.email_section?.length) {
    form.append("email_section", JSON.stringify(data.email_section));
  }

  return form;
};

export const useEditEwaiver = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  const editEwaiver = async (id: string, payload: EwaiverUpdatePayload) => {
    setLoading(true);
    setError(null);

    try {
      const res = await ewaiverApi.update(id, payload);
      return res;
    } catch (err: any) {
      console.error(`Edit e-waiver failed:`, err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    editEwaiver,
    loading,
    error,
  };
};
